import { CoreQuery } from '@/common/services/core-query';
import { EntitiesList } from '@/common/models';
import { httpClientCoreQuery } from '@/api/http-client';

export function unassignUsers(groupID: number, userIds: number[]) {
    const q = new CoreQuery()
        .entity([EntitiesList.USER_GROUPS, EntitiesList.PERSONA, EntitiesList.USER_GROUP, EntitiesList.UNASSIGN])
        .data({
            group_id: groupID,
            user_ids: userIds,
        });

    return httpClientCoreQuery.delete(q);
}
